import { CommonModule } from '@angular/common';
// Angular Imports
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsModalRef, ModalModule } from 'ngx-bootstrap/modal';
import { AirportLookupModule } from '../../common/airport-lookup/airport-lookup.module';
import { NgcCommonModule } from '../../common/common.module';
import { DataLayerModule } from '../../common/datalayer/datalayer.module';
import { DateSelectionModule } from '../../common/date-selection/date-selection.module';
import { ErrorHandlerModule } from '../../common/error-handler/error-handler.module';
import { HelpModalModule } from '../../help-modal/help-modal.module';
import { NgcStoreModule } from '../../store/store.module';
import { ChildPassengerComponent } from './childPassenger/childPassenger.component';
import { FlightItemComponent } from './multicity/flightitem/flightitem.component';
import { MulticityComponent } from './multicity/multicity.component';
// This Module's Components
import { FlyoutModalModule } from '../../flyout/flyout-modal/flyout-modal.module';
import { FlightPlusHotelModule } from './flight-plus-hotel/flight-plus-hotel.module';
import { NavigationBookComponent } from './navigation-book.component';
import { SearchOptionsComponent } from './search-options/search-options.component';

@NgModule({
  imports: [
    FormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode'
    }),
    ErrorHandlerModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode'
    }),
    NgcCommonModule,
    CommonModule,
    DataLayerModule,
    AirportLookupModule,
    HelpModalModule,
    ModalModule.forRoot(),
    DateSelectionModule,
    NgcStoreModule,
    FlightPlusHotelModule,
    FlyoutModalModule
  ],
  providers: [BsModalRef],
  declarations: [
    NavigationBookComponent,
    MulticityComponent,
    FlightItemComponent,
    ChildPassengerComponent,
    SearchOptionsComponent
  ],
  exports: [
    NavigationBookComponent,
    MulticityComponent,
    FlightItemComponent,
    ChildPassengerComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NavigationBookModule {}
